import PoweredBy from "./PoweredBy";

const Footer: React.FC = () => {

  return (
      <PoweredBy />
  )
};

export default Footer;
